import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Server_URL } from 'src/environments/environment';
import { environment } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root'
})
export class PartnersServiceService {
  public Data = new BehaviorSubject(null)

  constructor(private _HttpClient:HttpClient) { }

  GetPartners():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Partner/GetDB`);
  }
  GetPartnersByid(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Partner/GetByIdDB?Id=${id}`);
  }
  GetPartnersPaged(pager:any):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Partner/GetPagedDB`,pager);
  }
  DeletePartner(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Partner/Delete?id=${id}`);
  }

  CreatePartner(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Partner/Create`,data);
  }
  UpdatePartner(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Partner/Update`,data)
  }



}
